const baseUrl = process.env.REACT_APP_API_BASE_URL || '';

export default {
  name: 'CleanBill',
  base_url: baseUrl,
  graphql: {
    endpoint: baseUrl + (process.env.REACT_APP_API_GRAPHQL_ENDPOINT || '/api/graphql'),
  },
  api_file_brand: baseUrl + (process.env.REACT_APP_API_FILE_BRAND || '/api/file/brand/'),
  api_file_receipt: baseUrl + (process.env.REACT_APP_API_FILE_RECEIPTS || '/api/file/receipt/'),
  api_file_campaign: baseUrl + (process.env.REACT_APP_API_FILE_CAMPAIGN || '/api/file/campaign/'),
  stripe_api_key: process.env.REACT_APP_STRIPE_API_KEY || '',
};

